import _ from 'lodash'

export const RATING_CATEGORIES_MAP = {
  overall: 'Overall',
  team: 'Team',
  idea: 'Idea',
  innovation: 'Innovation',
  scalability: 'Scalability',
  competitive_advantages: 'Competitive advantages',
  business_model: 'Business model',
  traction: 'Traction',
}

export const RATING_CATEGORIES = _.entries(RATING_CATEGORIES_MAP).map(
  (pair) => pair[0],
)

export function ratingCategoryLabel(category) {
  return RATING_CATEGORIES_MAP[category]
}

export function hasCategoryRatings(rating) {
  const categories = RATING_CATEGORIES.filter((c) => c !== 'overall')
  for (const category of categories) {
    if (rating[category]) {
      return true
    }
  }
  return false
}
